import React from 'react';

import { FloorplanLegend } from './floorplan-legend';
import { FloorplanMap } from './floorplan-map';
import { FloorplanFixedColumn, FloorplanViewContainer } from './styles';
import { Floorplan } from '../types';

interface FloorplanViewProps {
  floorplan: Floorplan | null;
}

/**
 * The floorplan half of the resources page: the plan filling the space below the controls, with the
 * colour legend under it.
 *
 * The floor switcher is deliberately not here — it renders with the page's other controls so it
 * picks up their padding, while this surface stays full-bleed.
 *
 * Mounted only while the floorplan view is selected, so its queries do not run behind the list,
 * which is the default view.
 */
export const FloorplanView = ({ floorplan }: FloorplanViewProps): JSX.Element => (
  <FloorplanFixedColumn data-testid="floorplan-view">
    <FloorplanViewContainer>
      <FloorplanMap floorplan={floorplan} />
    </FloorplanViewContainer>
    <FloorplanLegend />
  </FloorplanFixedColumn>
);
